/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IShift } from 'app/shared/model/shift.model';
import { IDepartment } from 'app/shared/model/department.model';
import { IWard } from 'app/shared/model/ward.model';
import { IHospital } from 'app/shared/model/hospital.model';

export interface IDepartmentNeed {
  id?: string;
  shiftDate?: number | null;
  requestEndDate?: number | null;
  overTimeBonus?: number | null;
  minskillLevel?: number | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdate?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  neededCount?: number | null;
  shift?: IShift | null;
  department?: IDepartment | null;
  ward?: IWard | null;
  hospital?: IHospital | null;
}

export const defaultValue: Readonly<IDepartmentNeed> = {
  active: false,
};
